













import Vue from "vue";

export default Vue.extend({
  methods: {
    emit(area: string) {
      this.$emit(area);
    }
  }
});
